import { z } from 'zod';

export const ImageSizeInUriSchemaBuilder = <ImageSize extends number | `${number}`>(imageSizes: ImageSize[]) => {
  return z.object(
    Object.fromEntries(imageSizes.map((size: ImageSize) => [`${size}w`, z.string()])) as {
      [key in `${ImageSize}w`]: z.ZodString;
    },
  );
};

export const ImageSizeWithOriginalInUriSchemaBuilder = <ImageSize extends number | `${number}`>(imageSizes: ImageSize[]) => {
  return ImageSizeInUriSchemaBuilder(imageSizes).extend({ original: z.string() });
};
